import React from 'react';
import { FaroRoute } from '@grafana/faro-react';
import { Route } from 'react-router-dom';

const ErrorAwareRoute = (props) => {
  if (window?.baseAppConfig?.faroTransportUrl && window?.baseAppConfig?.faroApiKey) {
    return <FaroRoute {...props} />;
  }
  return <Route {...props} />;
};

export default ErrorAwareRoute;
